interface CustomToastProps {
  messages: string[];
}

export const CustomToast: React.FC<CustomToastProps> = ({ messages }) => (
  <div>
    {messages.map((msg, i) => (
      <div key={i}>{msg}</div>
    ))}
  </div>
);